var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlock = function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V6c0-2.2-1.8-4-4-4S6 3.8 6 6h2c0-1.1.9-2 2-2s2 .9 2 2v2H5c-.6 0-1 .4-1 1v6c0 1.7 1.3 3 3 3h6c1.7 0 3-1.3 3-3V9c0-.6-.4-1-1-1h-1z"
  })));
};
export default SvgUnlock;